import { pageInfoFragment } from "@saleor/fragments/pageInfo";
import makeQuery from "@saleor/hooks/makeQuery";
import gql from "graphql-tag";

import { RegisterList, RegisterListVariables } from "./types/RegisterList";

export const registerList = gql`
  ${pageInfoFragment}
  query RegisterList(
    $after: String
    $before: String
    $first: Int
    $last: Int
    $filter: RecommendFilterInput
    $sort: RecommendSortingInput
  ) {
    recommend(
      after: $after
      before: $before
      first: $first
      last: $last
      filter: $filter
      sortBy: $sort
    ) {
      totalCount
      edges {
        node {
          id
          fromEmail
          recommendEmail
          created
        }
      }
      pageInfo {
        ...PageInfoFragment
      }
    }
  }
`;
export const useRegisterListQuery = makeQuery<
  RegisterList,
  RegisterListVariables
>(registerList);
